export default __webpack_public_path__ + "paddle_internet04a029.svg";